import SkillCertService from "@/service/SkillCertService";
import MenuRightSerivce from "@/service/MenuRightService";
import SweetAlertService from "@/service/SweetAlertService";
import StoreGetter from "@/constants/StoreGetter";
import { SkillCerts } from "@/model/SkillCerts";
import t from "@/service/SysMsgService";
import dictEnum from "@/constants/SysMsgDict";
import skillCertsValidationObj from "./S080400-SkillCertsValidation.js";
import Paginate from "vuejs-paginate";
import Settings from "../../../constants/Settings.js";
var skillCertsDataValidationObj = new skillCertsValidationObj();
export default {
  name: "skillCert",
  mounted() {
    skillCertsDataValidationObj.skillCateValidation();
    this.assignRights();
    this.getAnsType();
    this.resetSkillCertData();
    this.init();
    this.getAllSkillCert();
  },
  components: {
    paginate: Paginate,
  },
  data: () => ({
    menuRights: { allRights: {}, rightsForThisMenu: {} },
    menuId: Settings.MenuID.S_Skill,
    Settings: Settings,
    dictEnum: dictEnum,
    skillCerts: new SkillCerts(),
    isEditMode: false,
    skillCertList: [],
    ansTypeList: [],
    selectAllSkillCert: false,
    tempSkillCertModel: new SkillCerts(),
    take: 10,
    skip: 0,
    totalNoOfPages: 0,
    noOfPages: 5,
    currentSelectedPage: 0,
    currentPage: 1,
    totalRecords: 0,
  }),
  computed: {
    t() {
      return t;
    },
    user() {
      return this.$store.getters[StoreGetter.user];
    },
  },
  methods: {
    init() {
      var self = this;
      var documentHeight = $(document).height();
      var headerHeight = $("nav").height();
      var tabHeight = $(".tab-header-section").height();
      var tableHeaderHeight = $(".SkillCert-table table thead").height();
      var pagginationHeight = $(".paggination-SkillCert").height();
      var docHeight = documentHeight != undefined ? documentHeight : 666;
      var headHeight = headerHeight != undefined ? headerHeight : 59;
      var tabHeaderHeight = tabHeight != undefined ? tabHeight : 36;
      var tHeadHeight = tableHeaderHeight != undefined && tableHeaderHeight != 0 ? tableHeaderHeight : 38;
      var paggHeight = pagginationHeight != undefined && pagginationHeight != 0 ? pagginationHeight : 22;
      var tableHeight = docHeight - headHeight - tabHeaderHeight - tHeadHeight - paggHeight - 70;
      self.take = Number((tableHeight / 50).toFixed());
    },
    hasRight(key, menuId) {
      if (Object.keys(this.menuRights.allRights).length === 0) {
        return false;
      } else {
        return MenuRightSerivce.hasRightInMenu(
          this.menuRights.allRights,
          menuId ? menuId : this.menuId,
          key
        );
      }
    },
    assignRights() {
      this.menuRights.allRights = this.$store.getters[StoreGetter.sysMenu];
      this.menuRights.rightsForThisMenu = this.menuRights.allRights.find(
        x => x.MenuID == this.menuId
      );
    },
    async getAllSkillCert() {
      var self = this;
      var obj = {
        take: self.take,
        skip: self.skip,
      }
      const response = await SkillCertService.getAllSkillCertByPagination(obj);
      if (response.data.IsSuccess) {
        self.skillCertList = response.data.Data.Item1;
        self.totalRecords = response.data.Data.Item2;
        self.totalPages();
        if (response.data.Data.Item1.length == 0 && response.data.Data.Item2 > 0) {
          self.changePage(self.currentPage - 1);
        }
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async getAnsType() {
      var self = this;
      const obj = {};
      const response = await SkillCertService.getAnsType(obj);
      if (response.data.IsSuccess) {
        self.ansTypeList = response.data.Data;
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async getSkillCertDetail() {
      var self = this;
      const obj = {
        skillCate: self.tempSkillCertModel.SkillCate,
        item: self.tempSkillCertModel.Item,
        seq: self.tempSkillCertModel.Seq,
      };
      const response = await SkillCertService.getSkillCertDetailByItem(obj);
      if (response.data.IsSuccess) {
        self.skillCerts = response.data.Data;
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    selectAllSkillCertRecord: function () {
      var self = this;
      var IsSelected = self.selectAllSkillCert;
      self.skillCertList.forEach(function (val, index) {
        val["isSelected"] = IsSelected;
      });
    },
    deleteMultipleSkillCertPopup: function () {
      var arrayList = [];
      var self = this;
      self.skillCertList.forEach(function (key, value) {
        if (key.isSelected) {
          arrayList.push(key);
        }
      });
      if (arrayList.length > 0) {
        $('#deleteSkillCertModel').modal('show');
      }
      else {
        SweetAlertService.warning("Warn", self.t.t(dictEnum.MSG_SelectDeleteRecord));
      }
    },
    async deleteMultipleSkillCert() {
      var arrayList = [];
      var self = this;
      $('#deleteSkillCertModel').modal('hide');
      self.skillCertList.forEach(function (key, value) {
        if (key.isSelected) {
          arrayList.push(key);
        }
      });
      const obj = {
        skillCertsList: arrayList,
      };
      const response = await SkillCertService.deleteSkillCert(obj);
      if (response.data.IsSuccess) {
        SweetAlertService.success("Success", response.data.Message);
        self.resetSkillCertData();
        self.init();
        await self.getAllSkillCert();
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    OnSkillCertSelect: function (model) {
      this.tempSkillCertModel = model;
    },
    addSkillCert: function () {
      var self = this;
      $('#skillCertModel').modal('show');
      self.isEditMode = false;
      self.skillCerts = new SkillCerts();
      self.$validator.reset();
      self.vErrors.clear();
    },
    async saveSkillCertData(obj) {
      var self = this;
      const response = await SkillCertService.addSkillCert(obj);
      if (response.data.IsSuccess) {
        SweetAlertService.success("Success", response.data.Message);
        self.resetSkillCertData();
        self.init();
        await self.getAllSkillCert();
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async EditSkillCertData(obj) {
      var self = this;
      const response = await SkillCertService.updateSkillCert(obj);
      if (response.data.IsSuccess) {
        SweetAlertService.success("Success", response.data.Message);
        self.resetSkillCertData();
        self.init();
        await self.getAllSkillCert();
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async saveSkillCert() {
      var self = this;
      self.$validator.validateAll().then(result => {
        if (result) {
          $('#skillCertModel').modal('hide');
          const obj = {
            model: {
              SkillCate: self.skillCerts.SkillCate,
              Item: self.skillCerts.Item,
              Seq: Number(self.skillCerts.Seq),
              CDesc: self.skillCerts.CDesc,
              EDesc: self.skillCerts.EDesc,
              AnsType: self.skillCerts.AnsType,
              OptValue: self.skillCerts.OptValue,
              DatePerReq: self.skillCerts.DatePerReq,
              AddBy: self.$store.getters[StoreGetter.user].UserID,
              ModifyBy: self.$store.getters[StoreGetter.user].UserID
            }
          };
          if (self.isEditMode) {
            self.EditSkillCertData(obj);
          }
          else {
            self.saveSkillCertData(obj);
          }
        }
      });
    },
    async editSkillCert() {
      var self = this;
      self.isEditMode = true;
      if (self.tempSkillCertModel.SkillCate != "") {
        await self.getSkillCertDetail();
        self.$validator.reset();
        self.vErrors.clear();
        $('#skillCertModel').modal('show');
      }
      else {
        SweetAlertService.warning("Warn", self.t.t(dictEnum.MSG_SelectEditRecord));
      }
    },
    resetSkillCertData: function () {
      var self = this;
      self.selectAllSkillCert = false;
      self.isEditMode = false;
      self.skillCerts = new SkillCerts();
      self.tempSkillCertModel = new SkillCerts();
      self.$validator.reset();
      self.vErrors.clear();
      self.take = 10;
      self.skip = 0;
      self.totalNoOfPages = 0;
      self.noOfPages = 5;
      self.currentSelectedPage = 0;
      self.currentPage = 1;
      self.totalRecords = 0;
    },
    closeSkillCertPopup: function () {
      var self = this;
      self.selectAllSkillCert = false;
      self.isEditMode = false;
      self.skillCerts = new SkillCerts();
      self.tempSkillCertModel = new SkillCerts();
      self.$validator.reset();
      self.vErrors.clear();
      $('#skillCertModel').modal('hide');
    },
    isNumber: function (evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    //Pagination Method start
    changePage(pagenumber) {
      this.currentPage = pagenumber;
      this.setPage();
    },
    setPage() {
      this.skip = this.take * (this.currentPage - 1);
      this.getAllSkillCert();
    },
    totalPages() {
      var numbers = this.totalRecords / this.take;
      var pages = 0;
      if (Number.isInteger(numbers)) {
        pages = numbers;
      } else {
        pages = Math.floor(numbers) + 1;
      }
      this.totalNoOfPages = pages;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/S080000-Setup/S080400-SkillCerts/S080400-SkillCerts.js